// ink-component
import React from 'react';
import CorePagination, { PaginationProps as CorePaginationProps } from '../../../Pagination/Pagination';

export interface PaginationProps extends CorePaginationProps {}

/**
 * @purpose Pagination component for Ledger implementations
 * @categories table
 * @group ledger
 */
const Pagination = ({ ...otherProps }: PaginationProps) => {
  return <CorePagination {...otherProps} />;
};

Pagination.defaultProps = {
  'data-testid': undefined,
};

Pagination.displayName = 'LedgerWrapper.Pagination';

export default Pagination;
